module.exports = __webpack_public_path__ + "static/media/fondo3.359c9328.png";